export function storefrontHref(base:string,orgId:number,org?:{id?:number}){
  if(!Number.isSafeInteger(orgId) || orgId<1000)return ''
  try{
    const url=new URL(base)
    if(!/^https?:$/.test(url.protocol) || url.username || url.password)return ''
    url.pathname='/';url.search='';url.hash=''
    if(orgId!==1000){if(Number(org?.id)!==orgId)return '';url.searchParams.set('shopOrgId',String(orgId))}
    return url.href
  }catch{return ''}
}
export function storefrontLogo(value:unknown,ossHost:string){
  const text=String(value || '').trim()
  if(!text || text.startsWith('//'))return ''
  try{const url=new URL(text,/^https?:\/\//i.test(ossHost)?ossHost.replace(/\/$/,'')+'/':undefined);return /^https?:$/.test(url.protocol)?url.href:''}catch{return ''}
}
